/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import AssetModel from 'cio/models/asset';
import AssetLibraryBaseItemComponent from 'cio/components/asset-library/base-item';

export default class AssetLibraryListItem extends AssetLibraryBaseItemComponent {
  @action
  onKeyUp(asset: AssetModel, ev: KeyboardEvent) {
    if (ev.key === 'Enter' || ev.key === ' ') {
      this.args.onSelect(asset);
    }
  }
}
